<div
    style="
        max-width: 1000px;
        margin: 0 auto;
        padding: 0 0 300px;
        border: 1px solid #ccc;
        border-radius: 10px;
        position: relative;
        margin-bottom: 20px;
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
    "
>
    <div
        style="
            background-color: #d7d7f7;
            padding: 40px;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
        "
    ></div>
    <div style="padding: 30px">
        <h2><b>Student Details Form</b></h2>
        <div style="margin-bottom: 15px">
            <label
                for="coun-id"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >CAMS ID
            </label>
            <div
                id="coun-id"
                name="coun-id"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.camsid }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="student-name"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Student Name</label
            >
            <div
                id="student-name"
                name="student-name"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.studentName }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="university-name"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >University Name</label
            >
            <div
                id="university-name"
                name="university-name"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.universityName }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="phone-number"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Phone Number</label
            >
            <div
                id="phone-number"
                name="phone-number"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.contactInfo }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="whatsapp-number"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >WhatsApp Number</label
            >
            <div
                id="whatsapp-number"
                name="whatsapp-number"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.whatsappNumber }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="email-id"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Email ID</label
            >
            <div
                id="email-id"
                name="email-id"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.studentDetails?.mailID }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="emergency-number"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Emergency Number</label
            >
            <div
                id="emergency-number"
                name="emergency-number"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ interviewDetails?.emergencynumber }}
            </div>
        </div>
        <div style="margin-bottom: 15px">
            <label
                for="belong-to"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Belongs To
            </label>
            <div
                type="text"
                id="belong-to"
                name="belong-to"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ interviewDetails?.belongsto }}
            </div>
        </div>
        <br />
        <br />
        <h2><b>Compulsory Questions</b></h2>
        <ng-container
            *ngFor="
                let questions of questionAnswer?.interviewQuestion?.questions
                    ?.compulsoryQuestionList;
                index as i
            "
        >
            <div
                style="
                    margin-bottom: 15px;
                    display: flex;
                    align-items: flex-start;
                "
            >
                <div style="width: 75%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                        "
                        [innerHTML]="questions?.question"
                    ></label>
                    <div
                        style="
                            width: 100%;
                            min-height: 200px;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            background: #fff;
                            margin-top: 10px;
                        "
                        [innerHTML]="questions?.answer"
                    ></div>
                </div>
                <div style="width: 20%; margin-left: 5%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                            margin-top: 10px;
                        "
                        >Remarks</label
                    >
                    <div
                        style="
                            width: 100%;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            margin-top: 10px;
                        "
                    >
                        {{ questions?.preparation }}
                    </div>
                </div>
            </div>
        </ng-container>

        <h2><b>University and Living-Expense Questions </b></h2>
        <ng-container
            *ngFor="
                let questions of questionAnswer?.interviewQuestion?.questions
                    ?.livingExpenseQuestions;
                index as i
            "
        >
            <div
                style="
                    margin-bottom: 15px;
                    display: flex;
                    align-items: flex-start;
                "
            >
                <div style="width: 75%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                        "
                        [innerHTML]="questions?.question"
                    ></label>
                    <div
                        style="
                            width: 100%;
                            min-height: 200px;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            background: #fff;
                            margin-top: 10px;
                        "
                        [innerHTML]="questions?.answer"
                    ></div>
                </div>
                <div style="width: 20%; margin-left: 5%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                            margin-top: 10px;
                        "
                        >Remarks</label
                    >
                    <div
                        style="
                            width: 100%;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            margin-top: 10px;
                        "
                    >
                        {{ questions?.preparation }}
                    </div>
                </div>
            </div>
        </ng-container>

        <h2><b>Financial Questions</b></h2>

        <ng-container
            *ngFor="
                let questions of questionAnswer?.interviewQuestion?.questions
                    ?.financialQuestions;
                index as i
            "
        >
            <div
                style="
                    margin-bottom: 15px;
                    display: flex;
                    align-items: flex-start;
                "
            >
                <div style="width: 75%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                        "
                        [innerHTML]="questions?.question"
                    ></label>
                    <div
                        style="
                            width: 100%;
                            min-height: 200px;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            background: #fff;
                            margin-top: 10px;
                        "
                        [innerHTML]="questions?.answer"
                    ></div>
                </div>
                <div style="width: 20%; margin-left: 5%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                            margin-top: 10px;
                        "
                        >Remarks</label
                    >
                    <div
                        style="
                            width: 100%;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            margin-top: 10px;
                        "
                    >
                        {{ questions?.preparation }}
                    </div>
                </div>
            </div>
        </ng-container>

        <h2><b>Additional Questions</b></h2>
        <ng-container
            *ngFor="
                let questions of questionAnswer?.interviewQuestion?.questions
                    ?.additionalQuestions;
                index as i
            "
        >
            <div
                style="
                    margin-bottom: 15px;
                    display: flex;
                    align-items: flex-start;
                "
            >
                <div style="width: 75%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                        "
                        [innerHTML]="questions?.question"
                    ></label>
                    <div
                        style="
                            width: 100%;
                            min-height: 200px;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            background: #fff;
                            margin-top: 10px;
                        "
                        [innerHTML]="questions?.answer"
                    ></div>
                </div>
                <div style="width: 20%; margin-left: 5%">
                    <label
                        style="
                            display: block;
                            margin-bottom: 5px;
                            font-weight: bold;
                            margin-top: 10px;
                        "
                        >Remarks</label
                    >
                    <div
                        style="
                            width: 100%;
                            padding: 8px;
                            box-sizing: border-box;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            margin-top: 10px;
                        "
                    >
                        {{ questions?.preparation }}
                    </div>
                </div>
            </div>
        </ng-container>

        <h2><b>Decision</b></h2>
        <div>
            <label
                for="question5"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Duration of Interview
            </label>
            <div
                type="text"
                id="remarks5"
                name="remarks5"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.interviewFeedback?.durationOftheInteview }}
            </div>
        </div>

        <br />

        <div>
            <label
                for="question5"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Interview Status
            </label>
            <div
                type="text"
                id="remarks5"
                name="remarks5"
                style="
                    width: 100%;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.interviewFeedback?.interviewStatus }}
            </div>
        </div>

        <br />

        <div>
            <label
                for="question5"
                style="display: block; margin-bottom: 5px; font-weight: bold"
                >Final Remarks
            </label>

            <div
                style="
                    width: 100%;
                    min-height: 200px;
                    padding: 8px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                "
            >
                {{ questionAnswer?.interviewFeedback?.finalRemarks }}
            </div>
        </div>
    </div>
</div>
